import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from './../../services/app.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../models/user.model';
import { GenericModel } from '../../models/generic.model'
import { environment } from '../../../environments/environment';
import { Session } from 'src/app/models/session.model';
import { Branch } from 'src/app/models/branch.model';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Component({
  selector: 'app-navbar-parent',
  templateUrl: './navbar-parent.component.html',
  styleUrls: ['./navbar-parent.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarParentComponent implements OnInit {
  
  constructor(
    private appService: AppService,
    private userService: UserService,private tokenStorageService: TokenStorageService,) {
  }

  isCollapsed = true;
  orgName: string;
  userDetail: GenericModel<User>;
  userId: string;
  profilePicUrl: string = '';
  branch: Branch;
    session: Session;
  sidebarPinned: boolean;

  ngOnInit() {
    console.log('*****NavbarParentComponent****');
    let hostname = window.location.hostname; // get tenant i.e subdomain from "subdomain.domain.com"
    let tenant = 'DemoTenant'
    if(hostname == 'localhost'){
      tenant = environment.defaultTenant
    }else{
      tenant= hostname.substring(0, hostname.indexOf('.'));
    }
    console.log(">>>>>Host Name:: "+hostname+' :tenant:>>>'+tenant);
    this.profilePicUrl = environment.authBase+environment.clientLogoUrl+tenant+'?X-TenantID='+tenant;
    this.getBranchDetail();  
    this.getActiveSession();
  }
  getBranchDetail(){
    console.log('>>>>>getBranchDetail- navbar-admin>>>>> ')
    let branchCode = this.tokenStorageService.getBranchCode();
    let tenantName = this.tokenStorageService.getTenantName();
    this.userService.getBranchDetail(branchCode,tenantName).subscribe({
      next: (response: any) => {
        console.log(">>>getBranchDetail from service:navbar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.branch =  response.data;
          if(this.branch){
            this.tokenStorageService.saveBranchName(this.branch.branchName);
          } 
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getBranchDetail....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }
  getActiveSession(){
    console.log('>>>>>getActiveSession- navbar-admin>>>>> ')
    this.userService.getActiveSession().subscribe({
      next: (response: any) => {
        console.log(">>>getActiveSession from service:navbar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.session =  response.data;
          if(this.session){
            this.tokenStorageService.saveAcademicSession(this.session.sessionYear);
          }          
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getActiveSession....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
    console.log('--------------toggleSidebarPin------------',this.appService.isSidebarPinned);
    this.sidebarPinned = this.appService.isSidebarPinned;
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
}
